
export const ScreenOrientationType = {
    portraitPrimary: 'portrait-primary',
    portraitSecondary: 'portrait-secondary',
    landscapePrimary: 'landscape-primary',
    landscapeSecondary: 'landscape-secondary'
};

export const ScreenOrientationMainType = {
    portrait: 'portrait',
    landscape: 'landscape'
};

ScreenOrientationType.getMainType = function(type)  {
    return type === ScreenOrientationType.landscapePrimary || type === ScreenOrientationType.landscapeSecondary ? ScreenOrientationMainType.landscape : ScreenOrientationMainType.portrait;
}

export const ScreenOrientation = new class {

    constructor() {
        this._type = typeof(screen.orientation) !== 'undefined' ? screen.orientation.type : ScreenOrientationType.portraitPrimary;
        this._mainType = ScreenOrientationType.getMainType(this._type);
        this._changeListener = [];

        this._onChange = function(event) {
            if(this._type === event.target.type)   return;
            this._type = event.target.type;
            this._mainType = ScreenOrientationType.getMainType(this._type);
            this.postChange();
        }.bind(this);

        if(typeof(screen.orientation) !== 'undefined')  screen.orientation.addEventListener('change', this._onChange);

        if(typeof(screen.orientation) !== 'undefined')  {
            console.log('Warning - no screen.orientation support');
        }
    }

    getType()   {
        return this._type;
    }

    getMainType()   {
        return this._mainType;
    }

    registerChangeListener(fn)  {
        if(this._changeListener.includes(fn))   return;
        if(this._changeListener.push(fn))   return;
    }

    unregisterChangeListener(fn)  {
        if(!(fn in this._changeListener)) return;
        this._changeListener = this._changeListener.filter(function(item) {
            return item !== fn;
        });
    }

    postChange()  {
        let event = {
            sender: this,
            type: this._type,
            mainType: this._mainType
        };
        
        let listener = this._changeListener;

        let postFn = function(fn)   {
            if(!this._changeListener.includes(fn)) return;
            fn(event);
        }.bind(this);

        listener.forEach(postFn);
    }
};